import Resource from "../base/resource";

class Animation extends Resource {
    id;
    name;
    duration;
    times;
    values;
    pivot;

    constructor(props) {
        super(props);
        this.id = props.id;
        this.name = props.name;
        this.duration = props.duration;
        this.times = props.times;
        this.values = props.values;
        this.pivot = null;
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        try {
            this.values.forEach(config => {
                config.normal = config.normal || [1, 0, 0];
                config.position = config.position || [0, 0, 0];
                config.angle = config.angle || 0;
            });

            const keyframes = this.times.map((value, index) => ({time: value, data: this.values[index]}));
            keyframes.sort((a, b) => a.time - b.time);
            this.times = keyframes.map(frame => frame.time);
            this.values = keyframes.map(frame => frame.data);
            if (this.times[0] !== 0) {
                this.times.unshift(0);
                this.values.unshift({
                    normal: [1, 0, 0],
                    position: [0, 0, 0],
                    angle: 0
                });
            }

            for (let i = 0; i < this.values.length; i++) {
                if (this.values[i].angle) {
                    this.pivot = this.values[i].pivot;
                    break;
                }
            }

            if (typeof onLoadCallback === 'function') {
                onLoadCallback(1);
            }
        } catch (error) {
            console.error(error);
        }
    }

    setState(state) {

    }

    getDefaultState() {
        return {};
    }
}

export default Animation;
